import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route } from 'react-router';

import Product from '@custom-types/Product';
import RoutePath from '@custom-types/RoutePath';
import Language from '@pages/Language';
import LeadCapture from '@pages/LeadCapture';
import { Onsite } from '@pages/Onsite';
import { generateRoute } from '@services/navigation-service';

import { CommonRoutes } from './CommonRoutes';
import NewAppAvailable from './pages/NewAppAvailable';
import { useIsObsoleteVersion } from './pages/UpdateRequired';

const UpdateRequiredRoute = () => (
  <IonRouterOutlet>
    <Route path={generateRoute([RoutePath.Language, RoutePath.OpenApp, RoutePath.UpdateRequired])}>
      <CommonRoutes />
    </Route>
    <Redirect
      to={{
        pathname: generateRoute(RoutePath.UpdateRequired),
      }}
    />
  </IonRouterOutlet>
);

export default () => {
  const isObsoleteVersion = useIsObsoleteVersion();

  return (
    <IonRouterOutlet id="main">
      <Route path={`/${Product.LeadCapture}`}>
        {isObsoleteVersion ? <UpdateRequiredRoute /> : <LeadCapture />}
      </Route>
      <Route path={`/${Product.CheckIn}`}>
        {isObsoleteVersion ? <UpdateRequiredRoute /> : <Onsite />}
      </Route>
      <Route path={`/${Product.Legacy}`}>
        <IonRouterOutlet>
          <Route exact path={generateRoute()}>
            <NewAppAvailable />
          </Route>
          <Route exact path={generateRoute(RoutePath.Language)}>
            <Language />
          </Route>
        </IonRouterOutlet>
      </Route>
      <Route exact path="/">
        <Redirect
          to={{
            pathname: `/${Product.Legacy}`,
          }}
        />
      </Route>
    </IonRouterOutlet>
  );
};
